import axios from 'axios';

const state = {
	items: [],
	item: {},
	index: '',
	sortBy: '',
	sortDesc: '',
};

const getters = {
	getItems: state => state.items,
	getItem: state => state.item,
	getIndex: state => state.index,
	getSortBy: state => state.sortBy,
	getSortDesc: state => state.sortDesc,
};

const actions = {
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		const url = 'banners';

		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: context.rootGetters['banners/getSortBy'],
						sortDesc: context.rootGetters['banners/getSortDesc'],
						page,
						itemsPerPage,
						filters: settings.filters ? settings.filters : {},
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => {
				context.commit('setItems', res.data.data);
				return res.data.pagination;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},
	getDetail: async (context, payload) => {
		const url = `banners/detail/${payload._id}`;

		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => {
				context.commit('setItem', res.data.data);
				return res.data.data;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},
	deleteItem: async (context, payload) => {
		const url = 'banners/delete';

		return await axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => res.data)
			.catch(err => {
				console.log('errore', err);
				throw err;
			});
	},
	destroyData: context => {
		context.commit('setItems', []);
		context.commit('setItem', {});
		context.commit('setIndex', '');
	},
};

const mutations = {
	setItems: (state, value) => {
		state.items = value;
	},
	setItem: (state, value) => {
		state.item = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
